export enum ElementTypes {
    TEXT = 'TEXT',
    IMAGE = 'IMAGE',
    VIDEO = 'VIDEO',
    SHAPE = 'SHAPE',
    GROUP = 'GROUP',
    AUDIO = 'AUDIO',
    BACKGROUND_COLOR = 'BACKGROUND_COLOR',
    POSTER_FRAME = 'POSTER_FRAME',
    TRANSCRIPT = 'TRANSCRIPT',
}
